import { Schema } from "effect";
import * as z from "zod";
import { ConversationId, SupportTicketId } from "./definitions";

const isSupportTicketId = Schema.is(SupportTicketId);
const isConversationId = Schema.is(ConversationId);

/**
 * Zod schema whose output is the Effect-branded {@link SupportTicketId}.
 * Validation is delegated to the Effect schema, so the format lives in one
 * place ({@link SupportTicketId}) and the parsed value is usable directly in
 * code that expects the branded Effect type.
 */
export const SupportTicketIdZod = z.custom<SupportTicketId>(
  (value) => isSupportTicketId(value),
  {
    error: () =>
      `Must be a SupportTicketId (${SupportTicketId.prefix}_<base62>)`,
  },
);

/**
 * Zod schema whose output is the Effect-branded {@link ConversationId}
 * (alias of `TopicId`). Validation is delegated to the Effect schema.
 */
export const ConversationIdZod = z.custom<ConversationId>(
  (value) => isConversationId(value),
  {
    error: () => `Must be a ConversationId (${ConversationId.prefix}_<base62>)`,
  },
);
